import { StoreStatusState } from 'acscp/store/storeStatusState';
import { ReduxAction } from 'acscp/actions';
import { actionTypes } from 'redux-localstorage';

const initialState: StoreStatusState = {
    storeRehydrationComplete: false,
};

// Using a "manual" implementation of a reducer instead of the ReducerBuilder helper,
// because we are handling a non-standard action provided by the library.
export function storeStatusReducer(state: StoreStatusState = initialState, action: ReduxAction<any>): StoreStatusState {
    if (action.type === actionTypes.INIT) {
        return {
            storeRehydrationComplete: true,
        };
    }

    return state;
}
